import Grid from '@material-ui/core/Grid';
import { createStyles, Link, makeStyles, Theme, Typography } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    spacer: {
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
      // borderBottom: `solid 1px ${theme.palette.text.disabled}`,
    },
    linkContainer: {
      marginRight: theme.spacing(2),
    },
    linkSize: {
      fontSize: '1.6em',
      textDecoration: 'underline',
    },
    linkText: {
      textDecoration: 'underline',
      fontWeight: 'bold',
    },
    contentSpacer: {
      paddingTop: theme.spacing(1),
    },
    contentItem: {
      paddingBottom: theme.spacing(4),
    },
    contentHeading: {
      paddingBottom: theme.spacing(1),
    },
  }),
);

export default function FAQPage() {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography id="TOP" variant="h4" color="primary" className={classes.spacer}>
        Tips and FAQs
      </Typography>
      <Grid item container className={classes.spacer}>
        <Grid item className={classes.linkContainer}>
          <Link href="#Tips" color="primary" className={classes.linkSize}>Tips</Link>
        </Grid>
        <Grid item>
          <Link href="#FAQs" color="primary" className={classes.linkSize}>FAQs</Link>
        </Grid>
      </Grid>
      <Grid item className={classes.spacer}>
        <Typography id="Tips" variant="h4" color="primary" className={classes.spacer}>
          Tips
        </Typography>
        <Grid item className={classes.contentItem}>
          <Typography variant="h6" color="primary" className={classes.contentHeading}>
            The Importance of Assigning Groups and 3 Ways To Post
          </Typography>
          <Typography variant="body1">
            <b>
              For each post you create, you will have the option to assign a group.
            </b>
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            <b>
              You may: 1) assign NO group and so keep your post a private journal entry,
              2) assign your post to a closed group you have created that only your
              approved followers can join, or 3) assign your post to a public group
              that everyone can follow.
            </b>
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            The first and most important thing to remember, your post remains private
            until you assign a group to the post. Also, the closed or public post does
            not go live until you toggle the switch to LIVE.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            You will have fields to enter a title, date, note and highlights.
            Highlights are images and/or short sentences or bullet points
            that show in your app feed above your post.
            It's a great way to catch someone's attention to your post.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            When you create a post, we will be autosaving for you.  You’ll notice that
            each post appears in your post list. Don’t be alarmed, as mentioned
            above—<b>posts cannot be seen by anyone until you assign a group <u>AND</u> go
              “LIVE”—TWO STEPS needed to go LIVE—so you can have extra confidence in when
              posts can be seen by others.</b>
          </Typography>
        </Grid>

        <Grid item className={classes.contentItem}>
          <Typography variant="h6" color="primary" className={classes.contentHeading}>
            1 - Private Post
          </Typography>
          <Typography variant="body1">
            To keep any post private, so only you can see it, simply keep the group
            field empty.  These private posts are your personal journal and a great
            way to get started.
          </Typography>
        </Grid>

        <Grid item className={classes.contentItem}>
          <Typography variant="h6" color="primary" className={classes.contentHeading}>
            2 - Closed Group Post
          </Typography>
          <Typography variant="body1">
            Closed groups require followers “JOIN”.  Once an individual has clicked to
            join your closed group, an “Approve Request” link will appear on your
            Groups page.  Requests from followers to join a closed group must be approved
            by you.  Once you approve that request to join, the follower will be able to
            see your live posts to that closed group.  You will also have the option to
            remove closed group followers from your Groups page.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            Begin by assigning the post to a closed group name.  Your group name should
            reflect a group, event, study, series, topic, campaign, etc. and help identify
            your group to followers.  You will most likely have multiple closed groups, so
            the group name should be unique and descriptive.  An example might be “Wednesday
            Night Small Group”.  And along with group names in your posts, to help identify
            you, followers will see your leader, church or ministry name as well as a title
            and date posted.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            To go LIVE with your closed group post, you will need to toggle “Not Live” to
            “Live”.  The followers who have already been approved to join your closed group
            will see this post once it’s LIVE.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            We do not police your posts.  However, as states in the Terms & Conditions, if we
            have report of inappropriate posts being made, we reserve the right to remove your
            posts and/or account.
          </Typography>
        </Grid>

        <Grid item className={classes.contentItem}>
          <Typography variant="h6" color="primary" className={classes.contentHeading}>
            3 - Public Group Post
          </Typography>
          <Typography variant="body1">
            Public posts can be viewed by anyone who follows you.  You don’t need to approve
            followers for public groups, however, you will have the option to remove those
            public followers on your Groups page.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            Begin by assigning the post to a public group name you’ve created.  Your group
            name should reflect a group, event, study, series, topic, campaign, etc. and help
            identify your post to followers.  You will most likely have multiple public groups,
            so the group name should be unique and descriptive.  Examples might be “2020
            Prophetic Conference”, “Church ABC Sermon Notes”, “5-Day Bible Challenge”, and so
            on. Group names may be ones you use in posts once a week, once a year, once a season
            or for a short or one time usage.  And along with group names in your posts, to help
            identify you, followers will see your leader, church or ministry name as well as a
            title and date posted.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            To go LIVE, you will need to toggle “Not Live” to “Live”.  Your public group followers
            will see this post once it’s LIVE.
          </Typography>
          <Typography variant="body1" className={classes.contentSpacer}>
            We do not police your posts.  However, as states in the Terms & Conditions, if we have
            report of inappropriate posts being made, we reserve the right to remove your posts
            and/or account.
          </Typography>
        </Grid>

      </Grid>
      <Grid item className={classes.spacer}>
        <Link href="#TOP" className={classes.linkText}>Back to top</Link>
      </Grid>
      <Grid item className={classes.spacer}>
        <Typography id="FAQs" variant="h4" color="primary" className={classes.spacer}>
          FAQs
        </Typography>
        <Typography className={classes.spacer}>
          FAQs will be coming.
        </Typography>
      </Grid>
      <Grid item className={classes.spacer}>
        <Link href="#TOP" color="primary" className={classes.linkText}>Back to top</Link>
      </Grid>
    </Grid>
  );
}
